import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dialog, RaisedButton } from 'material-ui';
import {reduxForm, Field, SubmissionError} from "redux-form";
import PropTypes from "prop-types";
import AutoComplete from './AutoComplete';

import _ from 'lodash';
import { AutoComplete as MUIAutoComplete } from 'material-ui';
import { TextField } from 'redux-form-material-ui';
import { required, format } from "redux-form-validators";
import api from 'services';
import * as sagaDomains from "sagas/domains";
import {execute} from "store/configureStore";
import {getListDomain} from "actions/domains";

const styles = {
    autoComplete: {
        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
        menuStyle: { width: 'auto' },
        textFieldStyle: { fontSize: '13px' },
    },
    textField: {
        style: {
            fontSize: '13px',
        }
    }
};

const autoCompleteOptions = {
    dataSourceConfig: { text: 'email', value: 'item' }
};

class DeleteDomain extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
        };

        this.dAutocomplete = _.debounce((searchText) => {
            if (searchText.length <= 2) {
                return;
            }

            api.findUser(searchText)
                .then((response) => {
                    const users = [];

                    response.data.data.forEach((user) => {
                        users.push(user);
                    });

                    this.setState({
                        users,
                    });
                })
                .catch(() => null);
        }, 1000);

        this.onChange = this.onChange.bind(this);
        this.onNewRequest = this.onNewRequest.bind(this);
    }

    onChange(searchText) {
        this.dAutocomplete(searchText);
    }

    onNewRequest(updateProperties, value) {
        this.props.change('user', value._id);
    }

    render() {
        const { toggle, isOpen } = this.props;
        const { users } = this.state;

        return (
            <React.Fragment>
                <RaisedButton
                    label='Connect new domain'
                    onClick={toggle}
                    primary
                />
                <Dialog
                    title='Connect new domain'
                    modal={false}
                    open={isOpen}
                    onRequestClose={this.toggle}
                >
                    <form autoComplete="off" onSubmit={this.props.handleSubmit}>
                        <div className="row">
                            <div className="col-xs-6">
                                <Field
                                    component={TextField}
                                    name='domain'
                                    floatingLabelText='Domain'
                                    validate={[ format({ with: /^([\w\.]+)\.([a-z]{2,6}\.?)(\/[\w\.]*)*\/?$/ }), required() ]}
                                    style={styles.textField.style}
                                />
                            </div>

                            <div className="col-xs-6">
                                <Field
                                    name='userSearch'
                                    component={AutoComplete}
                                    hintText='User'
                                    onUpdateInput={this.onChange}
                                    onNewRequest={this.onNewRequest}
                                    dataSource={users}
                                    floatingLabelText='User'
                                    dataSourceConfig={autoCompleteOptions.dataSourceConfig}
                                    selectValue={(value) => {
                                        return value.item;
                                    }}

                                    props={{
                                        listStyle: styles.autoComplete.listStyle,
                                        menuStyle: styles.autoComplete.menuStyle,
                                        textFieldStyle: styles.autoComplete.textFieldStyle,
                                        popoverProps: { canAutoPosition: true },
                                        filter: MUIAutoComplete.noFilter,
                                    }}
                                />
                            </div>
                        </div>
                        <Field
                            name='user'
                            validate={[ required() ]}
                            component={({ input: { value }, meta: { error, ...ddd }}) => {
                                if (error) {
                                    return <div className="error">{`Error field user: ${error}`}</div>;
                                }

                                return value ? <div>{`Id user - ${value}`}</div> : '';
                            }}
                        />
                        <div style={{ margin: '30px 0 0 0'}}>
                            <RaisedButton
                                label='Cancel'
                                onClick={toggle}
                                secondary
                            />

                            <RaisedButton
                                label='Connect'
                                type='submit'
                                style={{ margin: '0 0 0 10px'}}
                                primary
                            />
                        </div>
                    </form>
                </Dialog>
            </React.Fragment>
        );
    }
}

DeleteDomain.propTypes = {

};

DeleteDomain.defaultProps = {

};

const handleSubmit = async (values, dispatch, props) => {
    const response = await execute(sagaDomains.connectNewDomainToUser, values);

    if (response.status !== 200) {
        let errors = {};

        response.data.errors.forEach((error) => {
            errors = _.merge(errors, _.set({}, error.field, error.messages[0]));
        });

        throw new SubmissionError(errors);
    } else {
        props.getListDomain();
        props.toggle();
    }
};

const MyForm = reduxForm({
    form: 'connect-domain-to-user',
    enableReinitialize: true,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    onSubmit: handleSubmit,
})(DeleteDomain);

export default connect(
    () => {
        return {
            initialValues: { domain: '', user: '', userSearch: '' },
        };
    },
    dispatch => bindActionCreators({ getListDomain }, dispatch),
)(MyForm);


// WEBPACK FOOTER //
// ./app/components/Domains/Connect.jsx